export default __webpack_public_path__ + "static/media/background.c6feedf6.jpg";